import { ActionIcon, Box, Tooltip } from "@mantine/core";
import { createContext, useContext } from "react";
import { IconViewportNarrow, IconViewportWide } from "../icons";

export function PageWidthToggle() {
  const width = useContext(PageWidthContext);
  if (!width) return null;

  const label = width.wide ? "Use the default width" : "Use the full width";
  return (
    // The Box is what global.css hides and shows, an ActionIcon carrying a display of Mantine's own to argue with.
    <Box className="page-width-toggle">
      <Tooltip label={label} withArrow>
        <ActionIcon
          variant="subtle"
          color="gray"
          size="md"
          onClick={width.toggle}
          aria-label={label}
          aria-pressed={width.wide}
        >
          {width.wide
            ? <IconViewportNarrow size="1.25rem" stroke={1.5} />
            : <IconViewportWide size="1.25rem" stroke={1.5} />}
        </ActionIcon>
      </Tooltip>
    </Box>
  );
}

interface PageWidthValue {
  wide: boolean;
  toggle: () => void;
}

// The cap is `.main-container`'s, so the state behind it is the layout's and this is how the title row reaches it.
export const PageWidthContext = createContext<PageWidthValue | null>(null);
